import { GET, POST, PUT, DELETE } from './executer';
import apiServiceInstance from './apiService';
import type {
  Dashboard,
  DashboardLayoutItem,
  DashboardWidgetConfig,
  DashboardSettings,
  DashboardVisibility,
} from '../pages/Dashboards/widgets/types';

export type { Dashboard, DashboardLayoutItem, DashboardWidgetConfig };

interface CreateDashboardParams {
  title: string;
  description?: string;
  visibility?: DashboardVisibility;
  layout?: DashboardLayoutItem[];
  widgets?: DashboardWidgetConfig[];
  settings?: DashboardSettings;
}

interface UpdateDashboardParams {
  title?: string;
  description?: string;
  visibility?: DashboardVisibility;
  layout?: DashboardLayoutItem[];
  widgets?: DashboardWidgetConfig[];
  settings?: DashboardSettings;
}

class DashboardService {
  async listDashboards() {
    return await apiServiceInstance.client.execute<Dashboard[]>(GET, '/api/dashboards');
  }

  async getDashboard(id: string) {
    return await apiServiceInstance.client.execute<Dashboard>(GET, `/api/dashboards/${id}`);
  }

  async createDashboard(data: CreateDashboardParams) {
    return await apiServiceInstance.client.execute<Dashboard>(POST, '/api/dashboards', data);
  }

  async updateDashboard(id: string, data: UpdateDashboardParams) {
    return await apiServiceInstance.client.execute<void>(PUT, `/api/dashboards/${id}`, data);
  }

  async deleteDashboard(id: string) {
    return await apiServiceInstance.client.execute<void>(DELETE, `/api/dashboards/${id}`);
  }

  async cloneDashboard(id: string, title?: string) {
    return await apiServiceInstance.client.execute<Dashboard>(POST, `/api/dashboards/${id}/clone`, title ? { title } : undefined);
  }
}

const dashboardServiceInstance = new DashboardService();
export default dashboardServiceInstance;
